module.exports = __webpack_public_path__ + "static/gary-5f8a42d5bc97f8f50d3a7a9d4bc62807.png";